<div class="sh-form-group" [class.-sh-is-invalid]="isControlInvalid$ | async" [class]="formGroupStyling">
    <ng-content></ng-content>

    @if (currentActionItems) {
        <div class="sh-input-field-with-action">
            <ng-container *ngTemplateOutlet="inputField"></ng-container>
            @for (item of currentActionItems; track item) {
                <sh-action-item [item]="item" class="sh-action-group__item"> </sh-action-item>
            }
        </div>
    } @else {
        @if (canBeIndeterminate) {
            <sh-form-toggle-switch-complex-base
                class="sh-form-group__input"
                [formControl]="control"
                [label]="label"
                [description]="description"
                [id]="controlId"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [required]="isControlRequired$ | async"
                [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
                [invalid]="isControlInvalid$ | async"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [title]="control.disabled ? disabledMsg : ''"
            >
            </sh-form-toggle-switch-complex-base>
        } @else {
            <sh-form-toggle-switch-base
                class="sh-form-group__input"
                [formControl]="control"
                [label]="label"
                [description]="description"
                [id]="controlId"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [required]="isControlRequired$ | async"
                [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
                [invalid]="isControlInvalid$ | async"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [title]="control.disabled ? disabledMsg : ''"
            >
            </sh-form-toggle-switch-base>
        }
    }

    <ng-template #inputField>
        @if (canBeIndeterminate) {
            <sh-form-toggle-switch-complex-base
                class="sh-form-group__input"
                [formControl]="control"
                [label]="label"
                [description]="description"
                [id]="controlId"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [required]="isControlRequired$ | async"
                [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
                [invalid]="isControlInvalid$ | async"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [title]="control.disabled ? disabledMsg : ''"
            >
            </sh-form-toggle-switch-complex-base>
        } @else {
            <sh-form-toggle-switch-base
                class="sh-form-group__input"
                [formControl]="control"
                [label]="label"
                [description]="description"
                [id]="controlId"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [required]="isControlRequired$ | async"
                [attr.aria-describedBy]="(isControlInvalid$ | async) ? this.describeLabelId : null"
                [invalid]="isControlInvalid$ | async"
                [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
                [title]="control.disabled ? disabledMsg : ''"
            >
            </sh-form-toggle-switch-base>
        }
    </ng-template>

    @if (isControlInvalid$ | async) {
        <p [id]="describeLabelId" class="sh-form-group__feedback">{{ errorMsg }}</p>
    }
</div>
